import { Component, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalGeneralComponent } from 'src/app/shared/components/modal-general/modal-general.component';
import { environment } from 'src/environments/environment';
declare var hbspt: any;

@Component({
  selector: 'app-plan-de-estudio-posgrado',
  templateUrl: './plan-de-estudio-posgrado.component.html',
  styleUrls: ['./plan-de-estudio-posgrado.component.scss']
})
export class PlanDeEstudioPosgradoComponent implements OnInit {
  @Input() planData: any;
  @Input() methodPay: any;

  @Input() titlesPlanData: any;
  @Input() workload: any;
  @Input() backgroudColor: string;
  @Input() accreditation: string;
  html = '<p><img alt="" src="https://wadmin.uca.edu.ar/public/Ingreso/Ruedas%20-%20graficos/Econ%C3%B3micas/grafico-contador-publico.png" style="width: 100%;" /></p>';
  @Input() docentes: any = []
    ;
  expandedHtml = '';
  scale = 1;
  translateX = 0;
  translateY = 0;
  isDragging = false;
  startX = 0;
  startY = 0;
  lastMouseX = 0;
  lastMouseY = 0;
  isModalOpen = false;
  isDesktop: boolean;
  htmlsanitizado: any;
  selectedItemIndex: number | null = null;
  selectedItemPlan: any = null;
  titlehtml: any;
  showExpandButton = false;
  expanded = false;
  @ViewChild('contentWrapper') contentWrapper!: ElementRef;
  constructor(private renderer: Renderer2, public dialog: MatDialog, private domSanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.isDesktop = window.innerWidth > 767;
    this.getPlanData();
  }
  async getPlanData() {
    // Limpieza inicial
    this.planData = this.planData.filter(d => d.title && d.body);


    // Si existen docentes, espero a generar el HTML antes de avanzar
    if (this.docentes && this.docentes.length > 0) {
      (window as any).toggleDocente = this.toggleDocente.bind(this);

      // ⛔ ACÁ se bloquea hasta que se genere el HTML
      const bodyDocentes = await this.armarBodyDocentes(this.docentes);

      // Agrego el bloque de docentes
      this.planData.push({
        title: 'Docentes',
        body: bodyDocentes,
        hiddenTitle: true
      });
    }
     // Agrego método de pago
    const methodPayItem = this.methodPay.find(d => d.title && d.body);
    if (methodPayItem) this.planData.push(methodPayItem);


    // ✔ Si no hay docentes, se ejecuta inmediatamente.
    // ✔ Si hay docentes, se ejecuta después del await.
    this.onSelectItem(0);
  }

  toggleExpand() {
    this.expanded = !this.expanded;
    if (!this.expanded) {
      setTimeout(() => {
        this.contentWrapper.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 0); // espera a que Angular actualice la vista
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkShowMore();
  }
  onSelectItem(index: number) {
    this.selectedItemIndex = index;
    this.selectedItemPlan = this.planData[index];
    this.titlehtml = this.selectedItemPlan.title;
    if (this.selectedItemPlan.hiddenTitle) this.titlehtml = "";


    if (this.selectedItemPlan.popup == true) {
      this.dialog.open(ModalGeneralComponent, { panelClass: 'custom-dialog-container', data: { html: this.selectedItemPlan.body, title: this.selectedItemPlan.title, tipografy: "nunito-medium", tipografyTitle: "nunito-bold" } });
      this.htmlsanitizado = "";
      this.titlehtml = "";
      this.checkShowMore();
    } else {
      const body = this.selectedItemPlan.body.replace(
        /<(h[1-5]|span)([^>]*)>/g,
        `<$1$2 style="color: ${this.backgroudColor}">`
      );
      this.htmlsanitizado = this.domSanitizer.bypassSecurityTrustHtml(body);
        this.checkShowMore()
    }

  }


  checkShowMore() {
    let showMore = this.selectedItemPlan.showMore;
    if(showMore) {
    this.isDesktop = window.innerWidth > 768;
    setTimeout(() => {
      const wrapper = this.contentWrapper.nativeElement;
      const inner = wrapper.querySelector('.bodyplan');

      if (this.isDesktop && wrapper) {
        const innerHeight = inner.scrollHeight;
        const maxHeightPx = window.innerWidth * 0.35;
        this.expanded = false;
        this.showExpandButton = innerHeight > maxHeightPx;
      } else {
        this.expanded = true;
        this.showExpandButton = false;
      }
    }, 0);
    }else {
        this.expanded = true;
        this.showExpandButton = false;
     }
  }

  transformarYoutubeLinks(html: string): string {
    // Reemplaza todos los iframe con youtube.be a youtube.com/embed
    return html.replace(/src="https:\/\/youtu\.be\/([a-zA-Z0-9_-]+)(\?[^"]*)?"/g, (match, videoId, params) => {
      const embedUrl = `https://www.youtube.com/embed/${videoId}${params || ''}`;
      return `src="${embedUrl}"`;
    });
  }
  openModalForm = false;

  openModal() {
    this.openModalForm = true;
    /*hbspt.forms.create({
      region: "na1",
      portalId: "23647426",
      formId: "b2e6899b-83b4-4a49-92ff-92360afdd10d",
      target: '#hubspot-form' 
    });*/
  }
  flechaAbajoImg = '';
  flechaArribaImg = '';

  async armarBodyDocentes(docentes: any[]) {
    const tarjetas = await Promise.all(
      docentes.map(async (d, index) => {

        const redesHtml = await this.generarRedes(d);
        await this.armarFlechas();

        const tieneContenidoExtra =
          (d.description && d.description.trim() !== '') ||
          redesHtml.trim() !== '';

        return `
         <div class="docente-card">
 
           <div class="header">
             <img 
               class="foto" 
               src="${d.image ? environment.apiUrl + d.image : './assets/img/default-docentes.png'}" 
               alt="${d.name}"
               onerror="this.onerror=null; this.src='./assets/img/default-docentes.png';"
             />
 
             <div class="datos">
                ${d.name ? `<h3>${d.name}</h3>` : ''}
              <hr class="separador" style="border-bottom-color: ${this.backgroudColor};">

              ${d.title ? `<h4>${d.title}</h4>` : ''}
               <ul>
                 ${d.items.map(s => `<li>${s.texto}</li>`).join('')}
               </ul>
 
               <div class="cuerpo oculto" id="cuerpo-${index}">
                 ${d.description ? `<p>${d.description}</p>` : ''}
                 <div class="redes">
                   ${redesHtml}
                 </div>
               </div>
 
               ${tieneContenidoExtra ? `
                 <div class="toggle" onclick="toggleDocente(${index})">
                   <img 
                     src="${this.flechaAbajoImg}" 
                     id="flecha-down-${index}" 
                     class="flecha flecha-down"
                   />
 
                   <img 
                     src="${this.flechaArribaImg}" 
                     id="flecha-up-${index}" 
                     class="flecha flecha-up oculto"
                   />
                 </div>
 
                 <hr class="separador" style="border-bottom-color: ${this.backgroudColor};">
               ` : ''}
               
             </div>
 
           </div>
              
            
         </div>
       `;
      })
    );

    return tarjetas.join('');
  }
  async armarFlechas() {
    const downSvg = await (await fetch('./assets/svg/flecha-abajo.svg')).text();
    const upSvg = await (await fetch('./assets/svg/flecha-arriba.svg')).text();

    const downColored = this.changeSvgColor(downSvg, this.backgroudColor);
    const upColored = this.changeSvgColor(upSvg, this.backgroudColor);

    this.flechaAbajoImg = await this.svgToPngUrl(downColored, 30);
    this.flechaArribaImg = await this.svgToPngUrl(upColored, 30);
  }


  async generarRedes(d: any) {
    const redes = [
      { campo: "instagram", icono: "./assets/svg/instagram.svg" },
      { campo: "linkedin", icono: "./assets/svg/linkedin.svg" },
      { campo: "facebook", icono: "./assets/svg/facebook.svg" },
      { campo: "twitter", icono: "./assets/svg/twitter.svg" },
      { campo: "youtube", icono: "./assets/svg/youtube.svg" }
    ];

    const svgPromises = redes
      .filter(red => d[red.campo] && d[red.campo]?.trim() !== "")
      .map(async red => {

        let svgText = await (await fetch(red.icono)).text();
        svgText = this.changeSvgColor(svgText, this.backgroudColor);


        const pngUrl = await this.svgToPngUrl(svgText, 40);

        return `
        <a href="${d[red.campo]}" target="_blank" class="red-link">
          <img src="${pngUrl}" class="icon-red">
        </a>
      `;
      });

    return (await Promise.all(svgPromises)).join('');
  }


  changeSvgColor(svg: string, color: string): string {
    svg = svg.replace(/fill\s*=\s*["']#[0-9a-fA-F]{3,6}["']/g, `fill="${color}"`);
    svg = svg.replace(/fill:\s*#[0-9a-fA-F]{3,6}/g, `fill:${color}`);

    return svg;
  }
  svgToPngUrl(svg: string, size = 30): Promise<string> {
    return new Promise(resolve => {
      const img = new Image();
      const svgBlob = new Blob([svg], { type: "image/svg+xml" });
      const url = URL.createObjectURL(svgBlob);

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;

        const ctx = canvas.getContext("2d")!;
        ctx.drawImage(img, 0, 0, size, size);

        URL.revokeObjectURL(url);
        resolve(canvas.toDataURL("image/png")); // 👉 devuelve la image generada
      };

      img.src = url;
    });
  }
  toggleDocente(i) {
    const cuerpo = document.getElementById("cuerpo-" + i);
    const flechaDown = document.getElementById("flecha-down-" + i);
    const flechaUp = document.getElementById("flecha-up-" + i);
    const estabaOculto = cuerpo.classList.contains("oculto");

    if (estabaOculto) {
      cuerpo.classList.remove("oculto");
      cuerpo.classList.add("open");
      flechaDown.classList.add("oculto");
      flechaUp.classList.remove("oculto");
    } else {
      cuerpo.classList.add("oculto");
      cuerpo.classList.remove("open");
      flechaUp.classList.add("oculto");
      flechaDown.classList.remove("oculto");
    }
    setTimeout(() => {
      this.checkShowMore();
    }, 50);
  }
}
